module.exports = __webpack_public_path__ + "icon-back.png?52246b392839a997033d04ce5ad1cdf1";